import FormDamages from "../../../../Components/FormDamages";
import { Form } from "../../../../system/useForm";

const DAP07RemarksOther = ({ form }: { form: Form }) => {
	return <FormDamages name="remarks.othersTechnical" form={form} />;
};

export default DAP07RemarksOther;
